/**
 * Third-Party Licenses Page — Route Module (#8914)
 *
 * Renders the public client bundle's OWN third-party notices: every npm
 * package that contributes bytes to the bundle, every crate and vendored
 * dataset compiled into the domain WebAssembly modules (OpenCC's table among
 * them — the Apache-2.0 §4(a) obligation this page discharges), the Rust
 * toolchain row and any component embedded in another package's dist. The
 * list is not written here: it is derived in the bundle action from the
 * bundle's own metafile and FETCHED lazily (`THIRD_PARTY_NOTICES_URL`), so no
 * other page pays a byte for it and the page cannot drift from what ships.
 * The rendering is the shared `ThirdPartyNoticesList` the staff and
 * localization `/licenses` pages mount too; this module supplies the URL, the
 * labels from this app's catalog, the SEO head and the page container.
 *
 * Not indexable (`marketing/licenses` in manifests/routes.yaml): a licence
 * list is no search landing page.
 */
import { noIndexRoute } from '@/shared/lib/seo/robots';
import { PageContainer } from '@letsgethome/ui/page-container';
import { ThirdPartyNoticesList } from '@letsgethome/ui/third-party-notices';

import { SeoHead } from '../../../../shared/components/SeoHead';
import { useTranslations } from '../../../../shared/i18n/useTranslations';
import { THIRD_PARTY_NOTICES_URL } from '../components/third-party-notices';

export function Component() {
  const t = useTranslations('licenses');
  const tLegal = useTranslations('legal');
  const tCommon = useTranslations('common');

  return (
    <>
      <SeoHead
        title={t('seo.title')}
        description={t('seo.description')}
        robots={noIndexRoute('marketing/licenses')}
      />
      <PageContainer size="4xl" className="py-8 sm:px-6 lg:px-8">
        <ThirdPartyNoticesList
          url={THIRD_PARTY_NOTICES_URL}
          labels={{
            title: tLegal('licenses'),
            intro: t('intro'),
            loading: tCommon('loading'),
            emptyTitle: t('empty.title'),
            emptyDescription: t('empty.description'),
            section: {
              packages: t('section.packages'),
              wasm: t('section.wasm'),
              embedded: t('section.embedded'),
            },
            text: t('text'),
            via: (via) => t('via', { via }),
            pending: (issue) => t('pending', { issue }),
          }}
        />
      </PageContainer>
    </>
  );
}
